



































import { Component, Vue, Watch, PropSync, Prop, ProvideReactive, InjectReactive } from "vue-property-decorator";
import questionSet from "./index.vue";
import questionSubmitSet from "../questionnaireSubmitSet/index.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";

import { service } from "@modules/newCommunity/setup";
import { mixins } from "vue-class-component";
import commonMixins from "@mixins/commonNewMixins";
import templateTitleDialog from "./templateTitleDialog.vue";
type ResolveFunction = (value?: any) => void;
type RejectFunction = (reason?: any) => void;
@Component({
  name: "addSurveyForActivityDialog",
  components: { questionSet, questionSubmitSet, templateTitleDialog },
  filters: {},
})
export default class addSurveyForActivityDialog extends mixins(commonMixins) {
  @PropSync("modalVisible", { type: Boolean }) visible!: Boolean;
  @ProvideReactive()
  templateMode = false;
  @Prop({
    default: "",
  })
  questionnaireId?: string;
  @Prop({
    default: "",
  })
  templateId?: string;

  @Prop({
    default: "ADD",
  })
  openMode?: string;

  @Prop({ default: () => ({}) })
  success!: (result: string | number | object) => void;

  @Prop({ default: () => ({}) })
  templateSuccess!: (result: string | number | object) => void;

  @Prop({
    default: "",
  })
  editSpecialMode?: string;
  @Prop({
    default: "QUESTIONNAIRE",
  })
  activityQuestionnaireType?: string;
  @Prop({
    default: "QUESTIONNAIRE",
  })
  activityQuestionnaireProperty?: string;
  @Prop({
    default: false,
  })
  showVerificationConfig?: boolean;

  @Prop({
    default: () => {
      return {
        title: "自定义表单",
        label: "表单名称",
        type: "ACTIVITY",
      };
    },
  })
  surveyConfig?: any;
  @InjectReactive()
  surveyType!: string; // 区分表单类型 undefind/NORMAL-正常表单创建 LITERATURE-文献表单创建（学术征集、病例PPT、医学讲堂）

  @Watch("visible")
  inputValChange(val: any) {
    if (val) {
      this.handleDialogOpen();
    } else {
      console.log("handleDialogClose");
      this.handleDialogClose();
    }
  }
  handleDialogOpen() {
    this.visible = true;
    // this.findRewardingActivity();
    QuestionnaireEditModule.SET_isModel(this.openMode || "");
    QuestionnaireEditModule.SET_editSpecialMode(this.editSpecialMode || "");

    this.initQuestionnaire();
  }
  handleDialogClose() {
    (this.$refs.postForm as any).clearValidate();
    typeof this.reject === "function" && this.reject();
  }
  handleCancel() {
    this.visible = false;
    // 触发拒绝Promise
    if (typeof this.reject === "function") {
      this.reject(new Error("用户取消"));
    }
    this.$emit("cancel");
  }

  handleClose() {
    console.log("handleClose");
    // 触发拒绝Promise
    if (typeof this.reject === "function") {
      this.reject(new Error("弹窗关闭"));
    }
    this.$emit("close");
  }

  private localSubmit = {};
  private postForm = {
    title: "标题", // 标题
  };

  resolve: ResolveFunction | null = null;
  reject: RejectFunction | null = null;

  get rules() {
    return {
      title: [{ required: true, type: "string", message: "请输入" + this.surveyConfig.label, trigger: "blur" }],
    };
  }
  private id = "";
  private submitLoading = false;
  private activeIndex = 1;
  private questionType = "QUESTIONNAIRE";

  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get isAnswerMode() {
    return this.questionnaireType == "ANSWER";
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }
  get basicDataUniqueId() {
    return QuestionnaireEditModule.basicDataUniqueId;
  }
  get VUE_APP_WEN_LINK() {
    return process.env.VUE_APP_WEN_LINK;
  }

  private get basicData() {
    return QuestionnaireEditModule.basicData;
  }
  private get isModel() {
    return QuestionnaireEditModule.isModel;
  }
  @Watch("basicData", { deep: true, immediate: true })
  watchPropData() {
    console.log("payload", this.basicData);

    if (JSON.stringify(this.basicData) != JSON.stringify(this.localSubmit)) {
      const backup = JSON.parse(JSON.stringify(this.basicData));
      this.localSubmit = JSON.parse(JSON.stringify(backup));

      this.postForm = backup;
      this.clearValidate();
    }
  }
  // async validatorTitle(rule: any, value: any, callback: any) {
  //   // console.log("validator", this.basicData, this.basicData.cover, this.basicData.introduce);
  //   let res: any = null;
  //   if (this.surveyConfig.type === "TEMPLATE") res = await service.questionnaireTemplateCheckTitleUnique({ title: value, id: this.basicDataUniqueId || null, communityId: this.VX_comtyId, questionnaireType: this.questionnaireType, questionnaireSource: "DOCTOR" });
  //   else res = await formtemplateCheckTitleUnique({ title: value, id: this.basicDataUniqueId, questionnaireProperty: "ACTIVITY_MEDICAL", questionnaireSource: "DOCTOR", questionnaireType: this.questionnaireType });

  //   // console.log("formtemplateCheckTitleUnique", res);
  //   if (res) {
  //     callback();
  //   } else {
  //     callback(Error("名称已存在"));
  //   }
  // }
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
  ///
  dataInited = false;
  async initQuestionnaire(questionnaireId: any = "") {
    this.activeIndex = 1;
    this.postForm.title = "";
    QuestionnaireEditModule.SET_RESET_STORE();
    QuestionnaireEditModule.SET_showVerificationConfig(this.showVerificationConfig);

    QuestionnaireEditModule.SET_QUESTIONNAIRESOURCE_DATA("DOCTOR");
    QuestionnaireEditModule.SET_QUESTIONTYPE_PROPERTY(this.activityQuestionnaireProperty as string);
    QuestionnaireEditModule.SET_QUESTIONTYPE_DATA(this.activityQuestionnaireType as string);
    if (questionnaireId || this.questionnaireId) {
      QuestionnaireEditModule.SET_BASICDATA_ID(questionnaireId || this.questionnaireId);
      await QuestionnaireEditModule.GET_QUESTIONNAIRE_DETAIL(questionnaireId || this.questionnaireId);
    }
    if (this.showVerificationConfig) {
      QuestionnaireEditModule.SET_verificationConfig_verificationLogicSwitch("INFO");
    } else {
      QuestionnaireEditModule.SET_verificationConfig_verificationLogicSwitch("DISABLE");
    }
    this.dataInited = true;
  }
  async saveTemp() {
    if (this.isModel == "VIEW") {
      window.open(`${this.VUE_APP_WEN_LINK}/medic/nsurvey/${this.questionnaireId}?pageMode=preview`, "_blank", "height=800, width=375, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
    } else {
      let result = await (this as any).$refs.questionSet.CHECK_DATA_validate();
      if (result) {
        let saveres: any = await QuestionnaireEditModule.SAVE_QUESTIONNAIRE(this.basicDataUniqueId || "");
        this.submitLoading = false;

        if (saveres && saveres.data && saveres.code == 200) {
          QuestionnaireEditModule.SET_BASICDATA_ID(saveres.data);
          QuestionnaireEditModule.GET_QUESTIONNAIRE_DETAIL(saveres.data);
          window.open(`${this.VUE_APP_WEN_LINK}/medic/nsurvey/${saveres.data}?pageMode=preview`, "_blank", "height=800, width=375, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no");
        }
      }
    }
  }
  //
  templateTitleDialogVisible = false;
  templateEditingId = "";
  async nextStepToTemple() {
    let result = false;
    if (this.activeIndex == 2) {
      result = await (this as any).$refs.questionSet.CHECK_DATA_validate();
    }
    if (this.activeIndex == 3) {
      result = await (this as any).$refs.questionSubmitSet.CHECK_DATA_validate();
    }
    if (result) {
      // this.handleCommit(1);
      this.templateEditingId = "";

      if (this.templateId) {
        let refreshNew = await this.$confirm("该表单已经创建过模板，请选择是否需要更新原模板", "提示", {
          confirmButtonText: "更新",
          cancelButtonText: "创建新模板",
          distinguishCancelAndClose: true,
          type: "warning",
        })
          .then(() => {
            return "update";
          })
          .catch((action: any) => {
            // console.log("refreshNewcatch", tp);
            if (action == "cancel") {
              return "new";
            } else {
              return "close";
            }
          });
        if (refreshNew == "update") {
          this.templateEditingId = this.templateId as string;
          this.templateTitleDialogSuccess("");
        } else if (refreshNew == "new") {
          this.templateTitleDialogVisible = true;
        }
      } else {
        this.templateTitleDialogVisible = true;
      }
    }
  }
  async templateTitleDialogSuccess(title: string) {
    let id = await this.handleCommit();
    let templateRes = await service.questionnaireGenerationTemplate({ questionnaireId: id, formTemplateId: this.templateEditingId, title: title || undefined });
    // console.log("temDetail", temDetail);

    this.$emit("templateSuccess", templateRes.data);
    this.templateSuccess && typeof this.templateSuccess === "function" && this.templateSuccess(templateRes.data);
  }
  //

  open() {
    console.log("step3 1111");
    this.handleDialogOpen();
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async nextStep(status = 1) {
    // console.log("nextStep", status);
    if (this.activeIndex == 1) {
      let result = await (this.$refs.postForm as any).validate();
      if (result) {
        const backup = JSON.parse(JSON.stringify(this.postForm));
        QuestionnaireEditModule.SET_BASIC_LIST(backup);
        this.activeIndex++;
      }
    } else if (this.activeIndex == 2) {
      let result = await (this as any).$refs.questionSet.CHECK_DATA_validate();
      if (result) {
        if (this.isAnswerMode) {
          this.activeIndex++;
        } else {
          this.handleCommit(status);
        }
      }
    } else {
      let result = await (this as any).$refs.questionSubmitSet.CHECK_DATA_validate();
      console.log("estionSubmitSet.CHECK_DATA_vali", result);
      if (result) {
        this.handleCommit(status);
      }
    }
  }

  // $ handleModules
  private handleModules(index: number, alive: any) {
    console.log(index, alive);
  }
  getModulesConfigInstance() {
    return this.$refs.modulesConfig as any;
  }

  getSubmitConfigInstance() {
    return this.$refs.submitConfig as any;
  }

  // $ 上一步
  private preNextClick() {
    this.activeIndex--;
  }
  async handleCommit(status = 1) {
    // let result = await this.getSubmitConfigInstance().validate();
    // if (result) {
    // this.submitLoading = true;
    // console.log("handleCommit", status);

    try {
      let data: any = await QuestionnaireEditModule.SAVE_QUESTIONNAIRE(this.basicDataUniqueId || "");
      this.submitLoading = false;

      if (data && data.data && data.code == 200) {
        if (this.isAnswerMode) {
          let totalScore = this.basicData.totalScore;
          let questionnaireData = await QuestionnaireEditModule.GET_QUESTIONNAIRE_DETAIL(data.data);

          this.$message.success("提交成功");

          const params = {
            templateId: "",
            title: this.basicData.title,
            questionnaireId: data.data,
            totalScore: totalScore,
            resultList: questionnaireData.resultList,
          };
          this.$emit("success", params);
          this.success && typeof this.success === "function" && this.success(params);
          typeof this.resolve === "function" && this.resolve();
        } else {
          let questionnaireData = await QuestionnaireEditModule.GET_QUESTIONNAIRE_DETAIL(data.data);
          // console.log("handleCommit", questionnaireData);
          this.$message.success("提交成功");

          const params = {
            templateId: "",
            title: this.basicData.title,
            questionnaireId: data.data,
            participateUniqueCheck: questionnaireData.participateUniqueCheck,
            participateRepeatedClassId: questionnaireData.participateRepeatedClassId,
            participateRepeatedClassName: questionnaireData.participateRepeatedClassName,
          };
          this.$emit("success", params);
          this.success && typeof this.success === "function" && this.success(params);
          typeof this.resolve === "function" && this.resolve();
        }
        return data.data;
      } else {
        this.$message.error(data.message);
        return "";
      }
    } catch (error) {
      this.submitLoading = false;
    }
    // }
  }
}
